import { GenericService } from './generic-service'

class TagService extends GenericService {
  constructor () {
    super('/tags')
  }
}

export default new TagService()
